import React from 'react';
import PropTypes from 'prop-types';
import { ResponsiveProvider as RsPrvdr } from 'core/providers/Responsive';

const checkForKey = (name, value) => {
	// maybe use the kwarg ... 🤚
	if (typeof value !== "undefined") return value;
	// maybe use window default ... ☸️
	if (typeof window !== "object" || !window.cj) return value;
	// OMG set the window default ... 💥
	return window.cj[name];
};

const ResponsiveProvider = ({ children, ...rest }) => {
// these are the crate-ui defaults, just being explicit
	const props = {
		isMobile: true,
	};

	props.isMobile = checkForKey("isMobile", rest.isMobile);
	props.isTablet = checkForKey("isTablet", rest.isTablet);
	props.isDesktop = checkForKey("isDesktop", rest.isDesktop);

	return (
		<RsPrvdr {...props}>
			{ children }
		</RsPrvdr>
	);
};

ResponsiveProvider.propTypes = {
	children: PropTypes.node.isRequired,
};

export default ResponsiveProvider;
